/**
 * pledgepop-community.js
 *
 * Drives the community comments UI in the PledgePop theme section.
 * Reads config from <script id="pp-community-config"> JSON rendered by Liquid.
 * Communicates with the backend exclusively via the Shopify App Proxy at /apps/pledgepop/*.
 *
 * Security: All write actions (POST comment, TOGGLE_LIKE, UPLOAD_AVATAR) require
 * Shopify to inject a valid logged_in_customer_id via the App Proxy — the backend
 * verifies the HMAC on every App Proxy request, so the browser never holds credentials.
 */

// ── Mobile podium fix (comment-preview modal) ───────────────────────────────
(function () {
  var s = document.createElement('style');
  s.textContent = [
    '@media(max-width:749px){',
    '.stitch-pledge-popup .modal .podium{display:grid!important;grid-template-columns:repeat(3,1fr)!important;gap:8px!important;padding:8px 0!important;}',
    '.stitch-pledge-popup .podium-runner{transform:none!important;min-width:0!important;overflow:hidden!important;}',
    '.stitch-pledge-popup .podium-winner{transform:none!important;min-width:0!important;overflow:hidden!important;}',
    '.stitch-pledge-popup .podium-runner .podium-name{font-size:10px!important;font-weight:600!important;margin-top:6px!important;width:100%!important;max-width:100%!important;white-space:normal!important;word-break:break-word!important;overflow:hidden!important;text-align:center!important;}',
    '.stitch-pledge-popup .podium-winner .podium-name{width:100%!important;max-width:100%!important;white-space:normal!important;word-break:break-word!important;overflow:hidden!important;text-align:center!important;}',
    '}',
  ].join('');
  document.head.appendChild(s);
})();

(function () {
  'use strict';

  // ── Config ─────────────────────────────────────────────────────────────────

  var configEl = document.getElementById('pp-community-config');
  if (!configEl) return; // Not on a PledgePop product page
  var config;
  try {
    config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    console.error('[PledgePop Community] Could not parse config:', e);
    return;
  }

  var campaignHandle = config.campaignHandle;
  var shopUrl = config.shopUrl;
  // Server-rendered flag — can be stale with new Customer Accounts because the
  // Liquid `customer` object may be null on product pages even when logged in
  // (session-based rendering + CDN caching). Use client-side fallbacks.
  var isLoggedIn = !!config.isLoggedIn;
  if (!isLoggedIn) {
    // Fallback 1: Shopify's analytics tracking object (most reliable)
    try {
      if (window.__st && window.__st.cid) isLoggedIn = true;
    } catch (e) { /* ignore */ }

    // Fallback 2: ShopifyAnalytics meta (populated by theme layout)
    if (!isLoggedIn) {
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
            window.ShopifyAnalytics.meta.page && window.ShopifyAnalytics.meta.page.customerId) {
          isLoggedIn = true;
        }
      } catch (e) { /* ignore */ }
    }

    // Fallback 3: Check for Shopify customer cookies
    if (!isLoggedIn) {
      isLoggedIn = document.cookie.split(';').some(function (c) {
        var t = c.trim();
        return t.indexOf('_shopify_customer_id=') === 0;
      });
    }

    // Fallback 4: Check if the auth gate was NOT rendered (Liquid confirmed customer exists)
    // The {%- unless customer -%} block only omits #pp-auth-gate when customer IS present
    if (!isLoggedIn) {
      var authGateExists = document.getElementById('pp-auth-gate');
      var anonRow = document.querySelector('.stitch-pledge-popup .modal .comment-anon-row');
      // If the anon row ({% if customer %}) exists but auth gate doesn't → customer is logged in
      if (!authGateExists && anonRow) {
        isLoggedIn = true;
      }
    }

    if (isLoggedIn) {
      console.log('[PledgePop Community] Auth recovered via client-side fallback (Liquid customer was stale).');
    }
  }
  var campaignEnded = !!config.campaignEnded;
  var customerUsername = config.customerUsername || null;
  var customerAvatarUrl = config.customerAvatarUrl || null;

  if (!campaignHandle || !shopUrl) {
    console.warn('[PledgePop Community] Missing campaignHandle or shopUrl in config.');
    return;
  }

  // App Proxy base — relative URL so Shopify handles the HMAC automatically
  var PROXY_BASE = '/apps/pledgepop';

  var loginReturnUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname + window.location.search);

  // ── State ──────────────────────────────────────────────────────────────────

  var modalCursor = null;
  var currentSort = 'newest';
  var isFetchingPreview = false;
  var isFetchingModal = false;
  var totalCommentCount = 0;
  var hasUsername = !!customerUsername;

  // ── DOM refs (resolved after DOMContentLoaded) ────────────────────────────

  var previewList, modalList, previewText, filterTabs, modalLoadMoreBtn;

  // ── Helpers ────────────────────────────────────────────────────────────────

  function proxyUrl(path, extra) {
    var params = 'campaignId=' + encodeURIComponent(campaignHandle);
    if (extra) params += '&' + extra;
    params += '&cb=' + new Date().getTime();
    return PROXY_BASE + path + '?' + params;
  }

  // Inject sign-in tooltip CSS (subtle, minimal)
  var tooltipStyle = document.createElement('style');
  tooltipStyle.textContent = '.pp-like-signin-tooltip{position:absolute!important;bottom:calc(100% + 8px)!important;left:50%!important;transform:translateX(-50%)!important;background:#fff!important;color:#374151!important;padding:12px 20px!important;border-radius:12px!important;font-size:15px!important;line-height:1.4!important;white-space:nowrap!important;z-index:100!important;box-shadow:0 4px 20px rgba(0,0,0,0.12),0 0 0 1px rgba(0,0,0,0.05)!important;animation:ppFadeIn .15s ease!important;pointer-events:auto!important;letter-spacing:0.1px!important}.pp-like-signin-tooltip::after{content:""!important;position:absolute!important;top:100%!important;left:50%!important;transform:translateX(-50%)!important;border:7px solid transparent!important;border-top-color:#fff!important;filter:drop-shadow(0 2px 2px rgba(0,0,0,0.06))!important}.pp-like-signin-tooltip a{color:#2563eb!important;text-decoration:none!important;font-weight:600!important;font-size:15px!important;transition:color .15s}.pp-like-signin-tooltip a:hover{color:#1d4ed8!important;text-decoration:underline!important}@keyframes ppFadeIn{from{opacity:0;transform:translateX(-50%) translateY(4px)}to{opacity:1;transform:translateX(-50%) translateY(0)}}';
  document.head.appendChild(tooltipStyle);

  function showSigninTooltip(anchorEl, message) {
    document.querySelectorAll('.pp-like-signin-tooltip').forEach(function(t) { t.remove(); });
    var tip = document.createElement('div');
    tip.className = 'pp-like-signin-tooltip';
    tip.innerHTML = message || '<a href="' + loginReturnUrl + '">Sign in</a> to interact';
    anchorEl.style.position = 'relative';
    anchorEl.appendChild(tip);
    setTimeout(function() { tip.remove(); }, 3000);
    var close = function(e) {
      if (!tip.contains(e.target) && e.target !== anchorEl) {
        tip.remove();
        document.removeEventListener('click', close);
      }
    };
    setTimeout(function() { document.addEventListener('click', close); }, 10);
  }

  function timeAgo(ts) {
    var ms;
    if (ts && ts._seconds) {
      ms = ts._seconds * 1000;
    } else if (typeof ts === 'string' || typeof ts === 'number') {
      ms = new Date(ts).getTime();
    } else {
      return '';
    }
    var diff = Math.floor((Date.now() - ms) / 1000);
    if (diff < 60) return diff + 's';
    if (diff < 3600) return Math.floor(diff / 60) + 'm';
    if (diff < 86400) return Math.floor(diff / 3600) + 'h';
    if (diff < 2592000) return Math.floor(diff / 86400) + 'd';
    return Math.floor(diff / 2592000) + 'mo';
  }

  function initials(name) {
    if (!name) return '?';
    var parts = name.trim().split(' ');
    return (parts[0][0] + (parts[1] ? parts[1][0] : '')).toUpperCase();
  }

  function escHtml(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  // ── Badge label formatting ─────────────────────────────────────────────────

  function formatBadgeLabel(type) {
    if (!type) return '';
    var map = {
      'EARLY_BIRD': 'Early Bird',
      'early_bird': 'Early Bird',
      'TOP_BACKER': 'Top Backer',
      'top_backer': 'Top Backer',
      '2ND_TOP_BACKER': '2nd Top Backer',
      '3RD_TOP_BACKER': '3rd Top Backer'
    };
    return map[type] || type.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }

  function badgeIcon(type) {
    if (!type) return '';
    var t = type.toUpperCase();
    if (t === 'TOP_BACKER') return '🏆 ';
    if (t === 'EARLY_BIRD') return '🟢 ';
    return '';
  }

  // Returns inline style string for badge based on type
  function badgeStyle(type) {
    if (!type) return '';
    var base = 'border-radius:9999px;padding:4px 12px;border:1px solid;font-size:11px;font-weight:600;';
    var t = type.toUpperCase();
    if (t === 'TOP_BACKER') return base + 'background:#fef9e7;color:#b45309;border-color:#fbbf24;';
    if (t === 'EARLY_BIRD') return base + 'background:#ecfdf5;color:#065f46;border-color:#a7f3d0;';
    if (t === 'UWU_MEMBER') return base + 'background:#c4106f;color:#ffffff;border-color:#c4106f;';
    return base + 'background:#f3f4f6;color:#6b7280;border-color:#e5e7eb;';
  }

  // ── Super Comment badge & styling ─────────────────────────────────────────

  var SC_TIER_META = {
    1: { label: 'Super Comment', icon: '⭐', gradient: 'linear-gradient(90deg, #00C6FF, #0072FF)', border: '#3b82f6', bubbleBg: '#eff6ff' },
    2: { label: 'Super Comment', icon: '💚', gradient: 'linear-gradient(90deg, #11998E, #38EF7D)', border: '#10b981', bubbleBg: '#ecfdf5' },
    3: { label: 'Super Comment', icon: '💜', gradient: 'linear-gradient(90deg, #8E2DE2, #4A00E0)', border: '#a855f7', bubbleBg: '#f5f3ff' },
    4: { label: 'Super Comment', icon: '🔥', gradient: 'linear-gradient(90deg, #FF512F, #DD2476)', border: '#f97316', bubbleBg: '#fff7ed' }
  };

  // ===== Member bubble skin =====
  //
  // The comments payload may carry the complete saved handoff style for a member who
  // has set one. Entitlement is decided server-side: app_proxy.comments judges membership once per
  // page and strips the field from every comment whose author is not a current member, failing
  // closed if that lookup throws. So the field's PRESENCE is the entitlement -- do not re-check it
  // here.
  //
  // What is re-checked here is the VALUE, because this file is one deploy out of step with that
  // server for its whole life. Nothing from the payload is interpolated until it has matched a
  // pattern or produced a string this file owns: every colour must match a strict 6-digit hex (a
  // character set with no quote, semicolon or parenthesis in it, so it cannot escape the style
  // attribute it lands in), fill is compared by value, and shape is resolved through a lookup
  // whose RESULT is type-checked.
  //
  // ⛔ That last check is the point, not a formality. BUBBLE_SHAPE_RADIUS is a plain object, so a
  // shape of 'constructor', 'toString', 'valueOf', 'hasOwnProperty' or '__proto__' resolves to an
  // INHERITED member of Object.prototype rather than to undefined. Every one of those is truthy,
  // so a `if (!radius)` guard passes them straight through and the card ends up carrying
  // `border-radius:function Object() { [native code] }`. Guarding on `typeof radius === 'string'`
  // is what actually closes it: no property Object.prototype carries is a string, and it also
  // rejects any future map entry that is not one. An unrecognised OR inherited shape returns ''
  // and the card renders exactly as an unstyled one does.
  var BUBBLE_HEX_RE = /^#[0-9a-fA-F]{6}$/;
  var BUBBLE_DARK_TEXT = '#1a1220';
  var BUBBLE_LIGHT_TEXT = '#ffffff';

  // border-radius only -- nothing here may touch padding, margin, width or display, because a
  // member must not be able to change the geometry of a shared thread. The first corner stays at
  // the bubble's 4px tail in every shape so a styled card keeps the thread's speech-bubble idiom
  // instead of turning into a detached lozenge.
  var BUBBLE_SHAPE_RADIUS = {
    rounded: '4px 14px 14px 14px',
    pill: '4px 999px 999px 999px',
    sharp: '4px 6px 6px 6px'
  };
  var BUBBLE_GLOW_STYLES = {
    soft: true,
    bright: true,
    neon: true,
    pulsing: true,
    wave: true
  };

  // Mirrors the darkening the landing-page customizer applies to a solid bubble's border, so the
  // rendered card matches what the member was shown when they picked the colour.
  function shadeHex(hex, amt) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    var target = amt < 0 ? 0 : 255;
    var k = Math.abs(amt);
    function adj(v) { return Math.max(0, Math.min(255, Math.round(v + (target - v) * k))); }
    return 'rgb(' + adj(r) + ',' + adj(g) + ',' + adj(b) + ')';
  }

  function alphaHex(hex, alpha) {
    return 'rgba(' + parseInt(hex.slice(1, 3), 16) + ',' +
      parseInt(hex.slice(3, 5), 16) + ',' + parseInt(hex.slice(5, 7), 16) + ',' + alpha + ')';
  }

  function bubbleLuminance(hex) {
    var channels = [hex.slice(1, 3), hex.slice(3, 5), hex.slice(5, 7)].map(function (part) {
      var value = parseInt(part, 16) / 255;
      return value <= 0.03928 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
  }

  // Pick the approved foreground that actually measures better against the
  // rendered bubble. This replaces the handoff's fixed brightness cut-off,
  // which incorrectly chose white for Rose. Gradient endpoints use the same
  // average-luminance definition as the visual editor.
  function bubbleTextColor(backgrounds) {
    var backgroundLuminance = backgrounds.map(bubbleLuminance).reduce(function (total, value) {
      return total + value;
    }, 0) / backgrounds.length;
    function score(foreground) {
      var foregroundLuminance = bubbleLuminance(foreground);
      var lighter = Math.max(foregroundLuminance, backgroundLuminance);
      var darker = Math.min(foregroundLuminance, backgroundLuminance);
      return (lighter + 0.05) / (darker + 0.05);
    }
    return score(BUBBLE_DARK_TEXT) >= score(BUBBLE_LIGHT_TEXT)
      ? BUBBLE_DARK_TEXT
      : BUBBLE_LIGHT_TEXT;
  }

  function singleBubbleEmoji(value) {
    if (typeof value !== 'string') return '';
    var emoji = value.trim();
    if (emoji.normalize) emoji = emoji.normalize('NFC');
    if (!emoji || emoji.length > 32 || typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') return '';

    var segments = Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(emoji));
    if (segments.length !== 1) return '';
    try {
      var pictographic = new RegExp('\\p{Extended_Pictographic}', 'u');
      var flag = new RegExp('^\\p{Regional_Indicator}{2}$', 'u');
      var keycap = /^[#*0-9]\ufe0f?\u20e3$/u;
      return pictographic.test(emoji) || flag.test(emoji) || keycap.test(emoji) ? emoji : '';
    } catch (e) {
      return '';
    }
  }

  function memberBubblePresentation(style) {
    var empty = { css: '', className: '', sparkleHtml: '' };
    if (!style || typeof style !== 'object') return empty;

    var color = style.color;
    if (typeof color !== 'string' || !BUBBLE_HEX_RE.test(color)) return empty;
    color = color.toLowerCase();

    // typeof, not truthiness -- see the note above on inherited keys.
    var radius = BUBBLE_SHAPE_RADIUS[style.shape];
    if (typeof radius !== 'string') return empty;

    var fill = style.fill;
    if (fill !== 'solid' && fill !== 'outline' && fill !== 'gradient') return empty;

    var css = 'border-radius:' + radius + ';';
    var textColor = bubbleTextColor(['#ffffff']);

    if (fill === 'outline') {
      css += 'background:#ffffff;border:2.5px solid ' + color + ';';
    } else if (fill === 'gradient') {
      var colors = style.gradientColors;
      if (!Array.isArray(colors) || colors.length !== 2 ||
          typeof colors[0] !== 'string' || typeof colors[1] !== 'string' ||
          !BUBBLE_HEX_RE.test(colors[0]) || !BUBBLE_HEX_RE.test(colors[1])) return empty;
      var first = colors[0].toLowerCase();
      var second = colors[1].toLowerCase();
      css += 'background:linear-gradient(135deg,' + first + ',' + second + ');' +
        'border:1px solid ' + shadeHex(second, -0.1) + ';';
      textColor = bubbleTextColor([first, second]);
    } else {
      css += 'background:' + color + ';border:1px solid ' + shadeHex(color, -0.12) + ';';
      textColor = bubbleTextColor([color]);
    }
    css += '--pp-member-text:' + textColor + ';';

    var effects = style.effects;
    var glow = !!(effects && typeof effects === 'object' && effects.glow === true);
    var sparkle = !!(effects && typeof effects === 'object' && effects.sparkle === true);
    var classes = ['pp-comment-bubble--member'];

    if (glow) {
      var glowStyle = style.glowStyle;
      if (BUBBLE_GLOW_STYLES[glowStyle] !== true) return empty;
      if (glowStyle === 'soft') css += 'box-shadow:0 6px 18px 0 ' + alphaHex(color, 0.3) + ';';
      else if (glowStyle === 'bright') css += 'box-shadow:0 8px 28px 2px ' + alphaHex(color, 0.55) + ';';
      else if (glowStyle === 'neon') css += 'box-shadow:0 0 8px ' + alphaHex(color, 0.85) + ',0 0 20px ' + alphaHex(color, 0.6) + ',0 0 36px ' + alphaHex(color, 0.4) + ';';
      else classes.push('pp-member-glow--' + glowStyle);
    }

    var sparkleHtml = '';
    if (sparkle) {
      var emoji = singleBubbleEmoji(style.emoji);
      if (!emoji) return empty;
      classes.push('pp-member-sparkles');
      var escapedEmoji = escHtml(emoji);
      sparkleHtml = '<span class="pp-member-sparkle pp-member-sparkle--one">' + escapedEmoji + '</span>' +
        '<span class="pp-member-sparkle pp-member-sparkle--two">' + escapedEmoji + '</span>' +
        '<span class="pp-member-sparkle pp-member-sparkle--three">' + escapedEmoji + '</span>';
    }

    return { css: css, className: ' ' + classes.join(' '), sparkleHtml: sparkleHtml };
  }

  function superCommentBadgeHtml(tier) {
    var meta = SC_TIER_META[tier];
    if (!meta) return '';
    return '<span class="pp-sc-badge" style="' +
      'display:inline-flex;align-items:center;gap:4px;padding:4px 10px;' +
      'border-radius:6px;color:#fff;font-size:10px;font-weight:800;' +
      'text-transform:uppercase;letter-spacing:0.5px;' +
      'background:' + meta.gradient + ';' +
      '">' + meta.icon + ' ' + escHtml(meta.label) + '</span>';
  }

  function fmtPledge(amount, currency) {
    if (!amount && amount !== 0) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 0 }).format(amount); }
    catch (e) { return '$' + Math.round(amount); }
  }

  // ── Comment card renderer ──────────────────────────────────────────────────

  function renderCommentCard(comment) {
    var username = comment.username || 'Anonymous User';
    var avatar = comment.avatarUrl || '';
    var avatarHtml;

    /* A stored avatarUrl is not proof of an avatar.
     *
     * Every profile is seeded with one of six `avatar_default_*.svg` sentinel URLs, and those
     * files return 404, so a bare truthiness test renders an <img> that paints the browser's
     * broken-image state with the alt text showing through the circular crop. Only commenters
     * with a custom username carry one at all, which is why it reads as a custom-username bug.
     *
     * The guard is the one podiumAvatarHtml() already uses below, plus an onerror so a real
     * avatar URL that fails later also degrades to initials instead of a broken image.
     *
     * onerror restores '' rather than a display value on purpose. `.pp-comment-avatar-initials`
     * declares no display of its own -- it is a flex item of `.pp-comment-avatar`, so it
     * computes to `block`. Clearing the inline style returns the span to exactly the state
     * every already-working card renders in; naming a value would be a guess that happens to
     * look right.
     */
    var isRealAvatar = avatar && avatar.indexOf('avatar_default_') === -1;

    if (isRealAvatar) {
      avatarHtml = '<img class="pp-comment-avatar-img" src="' + escHtml(avatar) + '" alt="' + escHtml(username) + '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'\'">' +
        '<span class="pp-comment-avatar-initials" style="display:none">' + escHtml(initials(username)) + '</span>';
    } else {
      avatarHtml = '<span class="pp-comment-avatar-initials">' + escHtml(initials(username)) + '</span>';
    }

    // Badge pills
    var badgesHtml = '';
    var backerInfo = comment.backerInfo || {};
    var backerNum = comment.backerNumber || backerInfo.backerNumber;

    // Badge pills (e.g. "🏆 Top Backer", "✅ Early Bird")
    if (backerInfo.badges && backerInfo.badges.length) {
      backerInfo.badges.forEach(function (b) {
        var type = b.type || '';
        var label = formatBadgeLabel(b.label || type);
        if (!label || label.indexOf('Backer #') === 0) return;
        badgesHtml += '<span class="pp-comment-badge" style="' + badgeStyle(type) + '">' + badgeIcon(type) + escHtml(label) + '</span>';
      });
    }

    // "# Backer #N" pill — same rounded shape, blue color
    if (backerNum) {
      var bBase = 'border-radius:9999px;padding:4px 12px;border:1px solid;font-size:11px;font-weight:600;';
      var backerStyle = backerNum === 1
        ? bBase + 'background:linear-gradient(135deg,#fffbeb,#fef3c7);color:#92400e;border-color:#fbbf24;'
        : bBase + 'background:#eff6ff;color:#1d4ed8;border-color:#bfdbfe;';
      badgesHtml += '<span style="display:inline-flex;align-items:center;' + backerStyle + '">' +
        'Backer #' + escHtml(String(backerNum)) +
      '</span>';
    }

    var likedClass = comment.likedByUser ? ' liked' : '';
    var likeCount = comment.likesCount || 0;

    // Pledged amount from backer info
    var pledgedAmt = backerInfo.totalAmountPledged || 0;
    var pledgedCurrency = backerInfo.currency || 'USD';
    var pledgedHtml = pledgedAmt > 0
      ? '<span class="pp-comment-pledged">' + fmtPledge(pledgedAmt, pledgedCurrency) + ' Pledged</span>'
      : '';

    // Super Comment detection & elevated styling
    var scTier = comment.super_comment_tier || 0;
    var scMeta = SC_TIER_META[scTier] || null;

    // Prepend Super Comment badge before other badges
    if (scMeta) {
      badgesHtml = superCommentBadgeHtml(scTier) + badgesHtml;
    }

    // Bubble inline style. Two sources can want this one attribute: a Super Comment tier and a
    // member's own skin. TIER WINS OUTRIGHT -- see the PR body for what was rejected and why.
    var bubblePresentation = { css: '', className: '', sparkleHtml: '' };
    if (scMeta) {
      bubblePresentation.css = 'border-left:3px solid ' + scMeta.border + ';background:' + scMeta.bubbleBg + ';';
    } else {
      bubblePresentation = memberBubblePresentation(comment.bubbleStyle);
    }

    var card = document.createElement('div');
    card.className = 'pp-comment-card' + (scMeta ? ' pp-comment-card--super' : '');
    if (scMeta) card.dataset.scTier = String(scTier);
    card.dataset.commentId = comment.id;
    card.innerHTML =
      '<div class="pp-comment-avatar">' + avatarHtml + '</div>' +
      '<div class="pp-comment-body">' +
        '<div class="pp-comment-header">' +
          '<span class="pp-comment-username">' + escHtml(username) + '</span>' +
          (badgesHtml ? '<span class="pp-comment-pills">' + badgesHtml + '</span>' : '') +
        '</div>' +
        '<div class="pp-comment-bubble' + bubblePresentation.className + '"' +
          (bubblePresentation.css ? ' style="' + bubblePresentation.css + '"' : '') + '>' +
          '<p class="pp-comment-content">' + escHtml(comment.content) + '</p>' +
          bubblePresentation.sparkleHtml +
        '</div>' +
        '<div class="pp-comment-footer">' +
          pledgedHtml +
          '<div class="pp-comment-footer-right">' +
            (isLoggedIn
              ? '<button class="pp-like-btn' + likedClass + '" data-comment-id="' + escHtml(comment.id) + '" aria-label="Like">' +
                  '<span class="material-symbols-outlined">' + (comment.likedByUser ? 'favorite' : 'favorite_border') + '</span>' +
                  '<span class="pp-like-count">' + likeCount + '</span>' +
                '</button>'
              : '<span class="pp-like-display">' +
                  '<span class="material-symbols-outlined">favorite_border</span>' +
                  '<span class="pp-like-count">' + likeCount + '</span>' +
                '</span>'
            ) +
            '<span class="pp-comment-time">' + escHtml(timeAgo(comment.createdAt)) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    // Wire like button (logged in) or sign-in tooltip (logged out)
    if (isLoggedIn) {
      var likeBtn = card.querySelector('.pp-like-btn');
      if (likeBtn) {
        likeBtn.addEventListener('click', function () { handleLike(likeBtn, comment.id); });
      }
    } else {
      var likeDisplay = card.querySelector('.pp-like-display');
      if (likeDisplay) {
        likeDisplay.style.cursor = 'pointer';
        likeDisplay.addEventListener('click', function () {
          showSigninTooltip(likeDisplay, '<a href="' + loginReturnUrl + '">Sign in</a> to like');
        });
      }
    }

    return card;
  }

  // ── API calls ──────────────────────────────────────────────────────────────

  function fetchComments(cursor, sort, callback) {
    var extra = 'sort=' + encodeURIComponent(sort || 'newest');
    if (cursor) extra += '&cursor=' + encodeURIComponent(cursor);
    fetch(proxyUrl('/comments', extra))
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (e) { callback(e, null); });
  }

  function postComment(campaignId, content, isAnonymous, callback) {
    fetch(proxyUrl('/comments'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'CREATE_COMMENT',
        campaignId: campaignId,
        content: content,
        isAnonymous: isAnonymous
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (e) { callback(e, null); });
  }

  function handleLike(btn, commentId) {
    if (!isLoggedIn) return;
    // Guard against double-clicks while API call is in flight
    if (btn._liking) return;
    btn._liking = true;

    var wasLiked = btn.classList.contains('liked');
    var countEl = btn.querySelector('.pp-like-count');
    var iconEl = btn.querySelector('.material-symbols-outlined');
    var currentCount = parseInt(countEl ? countEl.textContent : '0', 10) || 0;

    // Optimistic update
    if (wasLiked) {
      btn.classList.remove('liked');
      if (iconEl) iconEl.textContent = 'favorite_border';
      if (countEl) countEl.textContent = Math.max(0, currentCount - 1);
    } else {
      btn.classList.add('liked');
      if (iconEl) iconEl.textContent = 'favorite';
      if (countEl) countEl.textContent = currentCount + 1;
    }

    fetch(proxyUrl('/comments'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'TOGGLE_LIKE', commentId: commentId })
    }).then(function () {
      btn._liking = false;
    }).catch(function () {
      btn._liking = false;
      // Revert on error
      if (wasLiked) {
        btn.classList.add('liked');
        if (iconEl) iconEl.textContent = 'favorite';
        if (countEl) countEl.textContent = currentCount;
      } else {
        btn.classList.remove('liked');
        if (iconEl) iconEl.textContent = 'favorite_border';
        if (countEl) countEl.textContent = currentCount;
      }
    });
  }

  // ── Render helpers ─────────────────────────────────────────────────────────

  function updateCommentCountDisplay(count) {
    totalCommentCount = count;
    document.querySelectorAll('.pp-community-comment-count, .pp-community-comment-count-inline, .pp-activity-comment-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function updatePreviewText(comments) {
    if (!previewText) return;
    if (comments && comments.length > 0) {
      previewText.textContent = (comments[0].username || 'Backer') + ': ' + (comments[0].content || '');
    }
  }

  function renderEmptyState(container) {
    container.innerHTML =
      '<div class="pp-comments-empty">' +
        '<span class="material-symbols-outlined">chat_bubble_outline</span>' +
        '<p>Be the first to comment!</p>' +
      '</div>';
  }

  // ── Top Backers / Podium ───────────────────────────────────────────────────

  function fetchTopBackers(callback) {
    fetch(proxyUrl('/backers', 'limit=3'))
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(null, data); })
      .catch(function (e) { callback(e, null); });
  }

  function podiumAvatarHtml(backer, isWinner) {
    if (backer && backer.avatarUrl && backer.avatarUrl.indexOf('avatar_default_') === -1) {
      return '<img src="' + escHtml(backer.avatarUrl) + '" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" loading="lazy" alt="" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'">' +
        '<div style="display:none;width:100%;height:100%;align-items:center;justify-content:center;background:#e5e7eb;border-radius:50%;font-size:' + (isWinner ? 22 : 18) + 'px;font-weight:700;color:#6b7280;">' + escHtml(initials(backer.username || 'Backer')) + '</div>';
    }
    var label = backer ? (backer.username || 'Backer') : '?';
    var fontSize = isWinner ? 22 : 18;
    return '<span style="font-size:' + fontSize + 'px;font-weight:700;color:#6b7280;">' + escHtml(initials(label)) + '</span>';
  }

  /**
   * Renders the 3-slot podium inside the modal sidebar (#pp-podium-sidebar).
   * Updates existing DOM nodes to avoid blowing away CSS transitions.
   */
  function renderPodiumSidebar(backers) {
    var podium = document.getElementById('pp-podium-sidebar');
    if (!podium) return;

    // HTML order: 2nd runner, 1st winner, 3rd runner
    var slots = [backers[1] || null, backers[0] || null, backers[2] || null];

    podium.querySelectorAll('.podium-runner, .podium-winner').forEach(function (cell, i) {
      var backer = slots[i];
      var isWinner = (i === 1);
      var circle = cell.querySelector('.podium-circle');
      var nameEl = cell.querySelector('.podium-name');
      var amountEl = cell.querySelector('.podium-amount');

      if (circle) {
        circle.innerHTML = podiumAvatarHtml(backer, isWinner);
        circle.style.display = 'flex';
        circle.style.alignItems = 'center';
        circle.style.justifyContent = 'center';
        circle.style.overflow = 'hidden';
        if (backer && (!backer.avatarUrl || backer.avatarUrl.indexOf('avatar_default_') !== -1)) {
          circle.style.background = '#e5e7eb';
        }
      }
      if (nameEl) {
        nameEl.textContent = backer ? (backer.username || 'Backer') : '–';
        nameEl.style.color = backer ? '' : '#ccc';
      }
      if (amountEl) {
        amountEl.textContent = backer ? fmtPledge(backer.totalAmountPledged, backer.currency) : '–';
      }

      // Backer number badge (same as main podium)
      var existingBadge = cell.querySelector('.pp-backer-num');
      if (existingBadge) existingBadge.remove();
      if (backer && backer.backerNumber && nameEl) {
        var badge = document.createElement('span');
        badge.className = 'pp-backer-num' + (backer.backerNumber === 1 ? ' pp-backer-num--top' : '');
        badge.style.fontSize = '10px';
        badge.style.marginTop = '2px';
        badge.textContent = (backer.backerNumber === 1 ? '⭐ ' : '') + 'Backer #' + backer.backerNumber;
        nameEl.parentNode.insertBefore(badge, nameEl.nextSibling);
      }
    });
  }

  /**
   * Renders the 3-slot podium on the main product page (#pp-podium-grid-main).
   * HTML order in the liquid is: 2nd, 1st, 3rd — matches the podium-cell[data-rank] values.
   */
  function renderPodiumMain(backers) {
    var grid = document.getElementById('pp-podium-grid-main');
    if (!grid) return;

    // Liquid renders: rank-2 cell, rank-1 cell, rank-3 cell (left-to-right)
    var slots = [backers[1] || null, backers[0] || null, backers[2] || null];

    grid.querySelectorAll('.podium-cell').forEach(function (cell, i) {
      var backer = slots[i];
      var isWinner = (i === 1);
      var imgEl = cell.querySelector('.podium-img');
      var nameEl = cell.querySelector('.podium-name');
      var amountEl = cell.querySelector('.podium-amount');

      if (imgEl) {
        if (backer) {
          imgEl.classList.remove('podium-placeholder');
          imgEl.innerHTML = podiumAvatarHtml(backer, isWinner);
          imgEl.style.display = 'flex';
          imgEl.style.alignItems = 'center';
          imgEl.style.justifyContent = 'center';
          imgEl.style.overflow = 'hidden';
          // Restore grey background for initials fallback (CSS class only has it on podium-placeholder)
          if (!backer.avatarUrl || backer.avatarUrl.indexOf('avatar_default_') !== -1) {
            imgEl.style.background = '#e5e7eb';
          } else {
            imgEl.style.background = '';
          }
        } else {
          imgEl.classList.add('podium-placeholder');
          imgEl.innerHTML = '';
          imgEl.style.background = '';
        }
      }
      if (nameEl) {
        nameEl.textContent = backer ? (backer.username || 'Backer') : '–';
        nameEl.style.color = backer ? '' : '#ccc';
      }
      if (amountEl) {
        amountEl.textContent = backer ? fmtPledge(backer.totalAmountPledged, backer.currency) : '–';
      }

      // Render backer number pill (insert after name, before amount)
      var existingBadge = cell.querySelector('.pp-backer-num');
      if (existingBadge) existingBadge.remove();
      if (backer && backer.backerNumber && nameEl) {
        var badge = document.createElement('span');
        badge.className = 'pp-backer-num' + (backer.backerNumber === 1 ? ' pp-backer-num--top' : '');
        badge.style.fontSize = '10px';
        badge.style.marginTop = '2px';
        badge.textContent = (backer.backerNumber === 1 ? '⭐ ' : '') + 'Backer #' + backer.backerNumber;
        // Insert after name element
        nameEl.parentNode.insertBefore(badge, nameEl.nextSibling);
      }
    });
  }

  function loadTopBackers() {
    fetchTopBackers(function (err, data) {
      if (err || !data || !data.backers) return;
      renderPodiumSidebar(data.backers);
      renderPodiumMain(data.backers);
    });
  }

  // ── Info tooltip ───────────────────────────────────────────────────────────

  function wireHideUsernameInfoTooltip() {
    // Wire info icons next to "Hide Username" checkboxes (addon step 1 + pledge modal)
    var hideInfoBtns = document.querySelectorAll('.stitch-pledge-popup .addon-hide-username-label .material-symbols-outlined, .stitch-pledge-popup .addon-checkbox-row .material-symbols-outlined');
    hideInfoBtns.forEach(function (icon) {
      // Make the icon a focusable button-like element
      icon.style.cssText = 'cursor:pointer;font-size:16px;color:#94a3b8;vertical-align:middle;position:relative;';
      var tip = document.createElement('div');
      tip.style.cssText = [
        'display:none',
        'position:absolute',
        'bottom:calc(100% + 10px)',
        'right:0',
        'width:260px',
        'background:#1e293b',
        'color:#e2e8f0',
        'font-size:13px',
        'line-height:1.6',
        'padding:14px 16px',
        'border-radius:12px',
        'z-index:200',
        'box-shadow:0 8px 24px rgba(0,0,0,0.25)',
        'pointer-events:none'
      ].join(';');
      tip.textContent = 'You may hide your username and profile image when you toggle "Hide Username". Your comment will be publicly visible while staying anonymous.';
      icon.appendChild(tip);
      var open = false;
      icon.addEventListener('click', function (e) {
        e.stopPropagation();
        open = !open;
        tip.style.display = open ? 'block' : 'none';
      });
      document.addEventListener('click', function () {
        if (open) { open = false; tip.style.display = 'none'; }
      });
    });
  }

  function wireInfoTooltip() {
    var infoBtn = document.querySelector('.stitch-pledge-popup .filter-info');
    if (!infoBtn) return;

    var tip = document.createElement('div');
    tip.className = 'pp-filter-info-tip';
    tip.style.cssText = [
      'display:none',
      'position:absolute',
      'bottom:calc(100% + 10px)',
      'right:0',
      'width:260px',
      'background:#1e293b',
      'color:#e2e8f0',
      'font-size:13px',
      'line-height:1.6',
      'padding:14px 16px',
      'border-radius:12px',
      'z-index:200',
      'box-shadow:0 8px 24px rgba(0,0,0,0.25)',
      'pointer-events:none'
    ].join(';');
    tip.textContent = 'Comments can only be left by backers of the project. Add your comment and proceed to pledge to leave your comment. You will be able to toggle to display your username or remain anonymous prior to checkout.';
    infoBtn.style.position = 'relative';
    infoBtn.appendChild(tip);

    var open = false;
    infoBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      open = !open;
      tip.style.display = open ? 'block' : 'none';
    });
    document.addEventListener('click', function () {
      if (open) { open = false; tip.style.display = 'none'; }
    });
  }

  // ── Preview list (inline on product page) ─────────────────────────────────

  function loadPreviewComments() {
    if (isFetchingPreview || !previewList) return;
    isFetchingPreview = true;
    previewList.classList.add('pp-loading');

    fetchComments(null, 'newest', function (err, data) {
      isFetchingPreview = false;
      previewList.classList.remove('pp-loading');

      if (err || !data || !data.comments) {
        renderEmptyState(previewList);
        return;
      }

      // Capture username state from server response
      if (data.userProfile && !data.userProfile.isAnonymousDefault) hasUsername = true;

      var comments = data.comments.slice(0, 3);
      updateCommentCountDisplay(data.comments.length);
      updatePreviewText(comments);
      updateCommentInputState();

      previewList.innerHTML = '';
      if (comments.length === 0) {
        renderEmptyState(previewList);
      } else {
        var seenIds = {};
        comments.forEach(function (c) {
          if (seenIds[c.id]) return;
          seenIds[c.id] = true;
          previewList.appendChild(renderCommentCard(c));
        });
      }
    });
  }

  // ── Modal list ─────────────────────────────────────────────────────────────

  function loadModalComments(reset) {
    if (isFetchingModal || !modalList) return;
    isFetchingModal = true;

    if (reset) {
      modalCursor = null;
      modalList.innerHTML = '';
    }

    modalList.classList.add('pp-loading');

    fetchComments(modalCursor, currentSort, function (err, data) {
      isFetchingModal = false;
      modalList.classList.remove('pp-loading');

      if (err || !data || !data.comments) {
        if (reset) renderEmptyState(modalList);
        return;
      }

      var comments = data.comments;
      modalCursor = data.meta && data.meta.nextCursor;

      if (reset) {
        modalList.innerHTML = '';
        updateCommentCountDisplay(comments.length >= 20 ? totalCommentCount : comments.length);
      }

      // Collect already-rendered comment IDs to avoid duplicates
      var existingIds = {};
      modalList.querySelectorAll('.pp-comment-card').forEach(function (card) {
        if (card.dataset.commentId) existingIds[card.dataset.commentId] = true;
      });

      if (comments.length === 0 && reset) {
        renderEmptyState(modalList);
      } else {
        comments.forEach(function (c) {
          if (existingIds[c.id]) return; // Skip duplicate
          modalList.appendChild(renderCommentCard(c));
        });
      }

      // Show/hide load more
      if (modalLoadMoreBtn) {
        modalLoadMoreBtn.style.display = modalCursor ? '' : 'none';
      }
    });
  }

  // ── Comment input gate ─────────────────────────────────────────────────────

  /**
   * Updates the comment input area's locked/unlocked state based on:
   * 1. Must be logged in
   * 2. Must have a username set (unless posting anonymously)
   */
  function updateCommentInputState() {
    // Input is always enabled — guests can type, auth gate shows on send
  }

  // ── Comment input send ─────────────────────────────────────────────────────

  function wireModalInput() {
    var inputEl = document.getElementById('pp-sidebar-comment');
    var anonCheckbox = document.querySelector('.stitch-pledge-popup .modal #modal-anonymous-pledge');

    // Re-evaluate gate whenever anonymous toggle changes
    if (anonCheckbox) {
      anonCheckbox.addEventListener('change', updateCommentInputState);
    }
    
    // Auth gate check
    window.showSuperCommentAuthError = function(msg) {
      var authGate = document.getElementById('pp-auth-gate');
      if (!isLoggedIn && authGate) {
        authGate.style.display = '';
      } else {
        alert(msg);
      }
    };
  }

  // ── Addon / pledge modal comment preview username ─────────────────────────

  function wireAddonUsernameDisplay() {
    var usernameEl = document.getElementById('addon-username-text');
    if (!usernameEl) return;

    var displayName = customerUsername || (isLoggedIn ? 'You' : 'Anonymous');
    usernameEl.textContent = displayName;
    usernameEl.dataset.realName = displayName;

    // Also update the pledge modal if present
    var pledgeUsernameEl = document.querySelector('#pp-pledge-modal .pp-comment-author-name');
    if (pledgeUsernameEl) {
      pledgeUsernameEl.textContent = displayName;
    }

    // User avatar display
    var userAvatarEl = document.getElementById('addon-user-avatar');
    if (userAvatarEl && customerAvatarUrl) {
      userAvatarEl.innerHTML = '<img src="' + escHtml(customerAvatarUrl) + '" alt="' + escHtml(displayName) + '" style="width:100%;height:100%;border-radius:50%;object-fit:cover;">';
    } else if (userAvatarEl) {
      userAvatarEl.innerHTML = '<span class="pp-comment-avatar-initials">' + escHtml(initials(displayName)) + '</span>';
    }
  }

  // ── Filter tabs ────────────────────────────────────────────────────────────

  function wireFilterTabs() {
    filterTabs = document.querySelectorAll('.stitch-pledge-popup .filter-tab');
    filterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        filterTabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');

        var text = tab.textContent.trim().toLowerCase();
        if (text === 'newest') currentSort = 'newest';
        else if (text === 'top backers') currentSort = 'top_backers';
        else if (text === 'most liked') currentSort = 'most_liked';

        loadModalComments(true);
      });
    });
  }

  // ── Load more button ───────────────────────────────────────────────────────

  function wireLoadMore() {
    modalLoadMoreBtn = document.querySelector('.stitch-pledge-popup .modal .pp-load-more-btn');
    if (!modalLoadMoreBtn) {
      // Inject one if not in HTML
      var scrollEl = document.querySelector('.stitch-pledge-popup .comments-scroll');
      if (scrollEl) {
        modalLoadMoreBtn = document.createElement('button');
        modalLoadMoreBtn.className = 'pp-load-more-btn';
        modalLoadMoreBtn.textContent = 'Load more';
        modalLoadMoreBtn.style.display = 'none';
        scrollEl.appendChild(modalLoadMoreBtn);
      }
    }
    if (modalLoadMoreBtn) {
      modalLoadMoreBtn.addEventListener('click', function () {
        loadModalComments(false);
      });
    }
  }

  // ── Modal open hook ────────────────────────────────────────────────────────

  // Intercept the existing openModal function to load comments on first open
  var _modalOpened = false;
  function hookModalOpen() {
    // Observe modal class changes to detect open
    var modal = document.querySelector('.stitch-pledge-popup .modal');
    if (!modal) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class') {
          var isActive = modal.classList.contains('active');
          if (isActive && !_modalOpened) {
            _modalOpened = true;
            loadModalComments(true);
            loadTopBackers(); // Refresh podium each time modal opens
          }
          if (!isActive) {
            _modalOpened = false; // Reset so next open re-fetches if needed
          }
        }
      });
    });
    observer.observe(modal, { attributes: true });
  }

  // ── Open / close modal helpers ─────────────────────────────────────────────

  function openModal() {
    var modal = document.querySelector('.stitch-pledge-popup .modal');
    var overlay = document.querySelector('.stitch-pledge-popup .overlay');
    if (modal) {
      modal.classList.remove('closing');
      modal.classList.add('active');
    }
    if (overlay) {
      overlay.classList.remove('closing');
      overlay.classList.add('active');
    }
    // Always reload comments on open to sync with sidebar posts
    _modalOpened = true;
    loadModalComments(true);
  }

  // closeModal is handled by pledgepop-scripts.liquid. The MutationObserver
  // above resets _modalOpened when 'active' is removed from the modal.

  function wireModalButtons() {
    // "View All" button below the preview list
    var viewAllBtn = document.getElementById('pp-btn-view-all');
    if (viewAllBtn) viewAllBtn.addEventListener('click', openModal);

    // Inline comment icon in the CTA row
    var inlineCommentBtn = document.getElementById('inline-comment-btn');
    if (inlineCommentBtn) inlineCommentBtn.addEventListener('click', openModal);

    // Footer comment icon (same behaviour)
    var footerCommentBtn = document.querySelector('.stitch-pledge-popup .btn-comment');
    if (footerCommentBtn) footerCommentBtn.addEventListener('click', openModal);

    // Comments link (the "X comments" preview row)
    var commentsLink = document.querySelector('.stitch-pledge-popup .comments-link');
    if (commentsLink) {
      commentsLink.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    }

    // NOTE: Close button + overlay handlers are wired by pledgepop-scripts.liquid.
    // Do NOT duplicate them here — it causes the flicker bug.
  }

  // ── Init ───────────────────────────────────────────────────────────────────

  function init() {
    previewList = document.getElementById('pp-comment-preview-list');
    modalList = document.getElementById('pp-modal-comment-list');
    previewText = document.querySelector('.pp-comment-preview-text');

    wireFilterTabs();
    wireLoadMore();
    wireModalInput();
    wireModalButtons();
    wireAddonUsernameDisplay();
    hookModalOpen();
    wireInfoTooltip();
    wireHideUsernameInfoTooltip();
    updateCommentInputState();

    // Load the inline preview comments
    loadPreviewComments();

    // Load top backers for both main-page podium and modal sidebar
    loadTopBackers();
  }

  // ── Super Comment UI Logic ────────────────────────────────────────────────−
  function initSuperCommentUI() {
    var pills = document.querySelectorAll('.sc-pill');
    var wrap = document.getElementById('sc-textarea-wrap');
    var badge = document.getElementById('sc-badge');
    var badgeIcon = document.getElementById('sc-badge-icon');
    var badgeText = document.getElementById('sc-badge-text');
    var sendBtn = document.getElementById('pp-sidebar-send');
    var sendText = document.getElementById('sc-send-text');
    var charLimit = document.getElementById('sc-char-limit');
    var textarea = document.getElementById('pp-sidebar-comment');
    var pledgeTextarea = document.getElementById('pp-pledge-comment');
    var addonTextarea = document.getElementById('addon-backer-comment');
    var _modalPillsExpandedOnce = false; // Guard for scrollIntoView

    if (!pills.length || !textarea) return;

    window.ppSuperCommentVariantId = ''; // Global for checkout hook
    window.ppSuperCommentPrice = 0; // Global for modal math sync
    window.ppSuperCommentTier = '0';

    /**
     * Returns whichever SC textarea (sidebar, pledge modal, or addon screen) is currently
     * focused, or null if none is. Used to restore focus after pill selection so the
     * mobile keyboard stays up.
     */
    function getActiveScTextarea() {
      var active = document.activeElement;
      if (active === textarea || active === pledgeTextarea || active === addonTextarea) return active;
      return null;
    }

    /**
     * Triggers a synchronous recalc of the pledge total by dispatching a change
     * event on the quantity input. No setTimeout — prevents layout shift delay.
     */
    function syncPledgeTotal() {
      var qInput = document.getElementById('pp-quantity');
      if (qInput) qInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    var icons = {
      1: 'star',
      2: 'thumb_up',
      3: 'favorite',
      4: 'emoji_events'
    };

    pills.forEach(function(pill) {
      // Prevent mousedown from stealing focus from the textarea (keeps mobile keyboard up)
      pill.addEventListener('mousedown', function(e) { e.preventDefault(); });
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var focusTarget = getActiveScTextarea();

        pills.forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        
        var tier = pill.getAttribute('data-tier');
        var price = pill.getAttribute('data-price');
        var variant = pill.getAttribute('data-variant');
        
        window.ppSuperCommentVariantId = variant;
        window.ppSuperCommentPrice = parseFloat(price) || 0;
        window.ppSuperCommentTier = tier;
        
        var modalWrap = document.getElementById('modal-textarea-wrap');
        var modalBadge = document.getElementById('modal-sc-badge');
        var modalBadgeIcon = document.getElementById('modal-sc-badge-icon');
        var modalBadgeText = document.getElementById('modal-sc-badge-text');
        var addonWrap = document.getElementById('addon-textarea-wrap');
        var addonBadge = document.getElementById('addon-sc-badge');
        var addonBadgeIcon = document.getElementById('addon-sc-badge-icon');
        var addonBadgeText = document.getElementById('addon-sc-badge-text');

        // Update styling DOM classes for accents
        if(wrap) wrap.setAttribute('data-tier', tier);
        if(badge) badge.setAttribute('data-tier', tier);
        if(sendBtn) sendBtn.setAttribute('data-tier', tier);

        // Update Modal styling DOM classes for accents
        if(modalWrap) modalWrap.setAttribute('data-tier', tier);
        if(modalBadge) modalBadge.setAttribute('data-tier', tier);

        // Update Addon Screen styling DOM classes for accents
        if(addonWrap) addonWrap.setAttribute('data-tier', tier);
        if(addonBadge) addonBadge.setAttribute('data-tier', tier);

        if (tier === '0' || tier === 0) {
          if(badge) badge.style.display = 'none';
          if(sendText) sendText.textContent = '';
          if(modalBadge) modalBadge.style.display = 'none';
          if(addonBadge) addonBadge.style.display = 'none';
        } else {
          if(badge) badge.style.display = 'inline-flex';
          if(badgeIcon) badgeIcon.textContent = icons[tier] || 'star';
          if(badgeText) badgeText.textContent = 'SUPER COMMENT TIER ' + tier;
          if(sendText) sendText.textContent = '+$' + price + ' Super Comment';

          if(modalBadge) modalBadge.style.display = 'inline-flex';
          if(modalBadgeIcon) modalBadgeIcon.textContent = icons[tier] || 'star';
          if(modalBadgeText) modalBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;

          if(addonBadge) addonBadge.style.display = 'inline-flex';
          if(addonBadgeIcon) addonBadgeIcon.textContent = icons[tier] || 'star';
          if(addonBadgeText) addonBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;
        }

        // Sync Modal Pills Visually
        var mPills = document.querySelectorAll('.modal-sc-pill');
        mPills.forEach(function(p) { p.classList.remove('active'); });
        var matchingModalPill = document.querySelector('.modal-sc-pill[data-tier="'+tier+'"]');
        if(matchingModalPill) matchingModalPill.classList.add('active');

        // Sync Addon Screen Pills Visually
        var aPills = document.querySelectorAll('.addon-sc-pill');
        aPills.forEach(function(p) { p.classList.remove('active'); });
        var matchingAddonPill = document.querySelector('.addon-sc-pill[data-tier="'+tier+'"]');
        if(matchingAddonPill) matchingAddonPill.classList.add('active');

        // Restore textarea focus so keyboard stays up on mobile
        if (focusTarget) focusTarget.focus();

        // Synchronous recalc — no setTimeout jank
        syncPledgeTotal();
      });
    });

    textarea.addEventListener('input', function() {
      if(charLimit) {
        var len = textarea.value.length;
        charLimit.textContent = len + '/140';
      }
    });

    // Modal-specific Super Comment Selectors
    var modalPills = document.querySelectorAll('.modal-sc-pill');
    modalPills.forEach(function(pill) {
      pill.addEventListener('mousedown', function(e) { e.preventDefault(); });
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var focusTarget = getActiveScTextarea();

        modalPills.forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');
        
        var tier = pill.getAttribute('data-tier');
        var price = pill.getAttribute('data-price');
        var variant = pill.getAttribute('data-variant');
        
        // Sync Globals
        window.ppSuperCommentVariantId = variant;
        window.ppSuperCommentPrice = parseFloat(price) || 0;
        window.ppSuperCommentTier = tier;
        
        var modalWrap = document.getElementById('modal-textarea-wrap');
        var modalBadge = document.getElementById('modal-sc-badge');
        var modalBadgeIcon = document.getElementById('modal-sc-badge-icon');
        var modalBadgeText = document.getElementById('modal-sc-badge-text');
        var addonWrap = document.getElementById('addon-textarea-wrap');
        var addonBadge = document.getElementById('addon-sc-badge');
        var addonBadgeIcon = document.getElementById('addon-sc-badge-icon');
        var addonBadgeText = document.getElementById('addon-sc-badge-text');

        // Sync Sidebar Pills Visually
        var sPills = document.querySelectorAll('.sc-pill:not(.modal-sc-pill):not(.addon-sc-pill)');
        sPills.forEach(function(p) { p.classList.remove('active'); });
        var matchingSidebarPill = document.querySelector('.sc-pill:not(.modal-sc-pill):not(.addon-sc-pill)[data-tier="'+tier+'"]');
        if(matchingSidebarPill) matchingSidebarPill.classList.add('active');

        // Sync Addon Screen Pills Visually
        var aPillsM = document.querySelectorAll('.addon-sc-pill');
        aPillsM.forEach(function(p) { p.classList.remove('active'); });
        var matchingAddonPillM = document.querySelector('.addon-sc-pill[data-tier="'+tier+'"]');
        if(matchingAddonPillM) matchingAddonPillM.classList.add('active');

        // Update Sidebar UI hooks
        if(wrap) wrap.setAttribute('data-tier', tier);
        if(badge) badge.setAttribute('data-tier', tier);
        if(sendBtn) sendBtn.setAttribute('data-tier', tier);

        // Update Modal styling DOM classes for accents
        if(modalWrap) modalWrap.setAttribute('data-tier', tier);
        if(modalBadge) modalBadge.setAttribute('data-tier', tier);

        // Update Addon Screen styling DOM classes for accents
        if(addonWrap) addonWrap.setAttribute('data-tier', tier);
        if(addonBadge) addonBadge.setAttribute('data-tier', tier);

        if (tier === '0' || tier === 0) {
          if(badge) badge.style.display = 'none';
          if(sendText) sendText.textContent = '';
          if(modalBadge) modalBadge.style.display = 'none';
          if(addonBadge) addonBadge.style.display = 'none';
        } else {
          if(badge) badge.style.display = 'inline-flex';
          if(badgeIcon) badgeIcon.textContent = icons[tier] || 'star';
          if(badgeText) badgeText.textContent = 'SUPER COMMENT TIER ' + tier;
          if(sendText) sendText.textContent = '+$' + price + ' Super Comment';

          if(modalBadge) modalBadge.style.display = 'inline-flex';
          if(modalBadgeIcon) modalBadgeIcon.textContent = icons[tier] || 'star';
          if(modalBadgeText) modalBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;

          if(addonBadge) addonBadge.style.display = 'inline-flex';
          if(addonBadgeIcon) addonBadgeIcon.textContent = icons[tier] || 'star';
          if(addonBadgeText) addonBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;
        }

        // Restore textarea focus so keyboard stays up on mobile
        if (focusTarget) focusTarget.focus();

        // Synchronous recalc — no setTimeout jank
        syncPledgeTotal();
      });
    });

    // ── Addon Screen Super Comment Pills ──────────────────────────────────────
    var addonPills = document.querySelectorAll('.addon-sc-pill');
    addonPills.forEach(function(pill) {
      pill.addEventListener('mousedown', function(e) { e.preventDefault(); });
      pill.addEventListener('click', function(e) {
        e.preventDefault();
        var focusTarget = getActiveScTextarea();

        addonPills.forEach(function(p) { p.classList.remove('active'); });
        pill.classList.add('active');

        var tier = pill.getAttribute('data-tier');
        var price = pill.getAttribute('data-price');
        var variant = pill.getAttribute('data-variant');

        window.ppSuperCommentVariantId = variant;
        window.ppSuperCommentPrice = parseFloat(price) || 0;
        window.ppSuperCommentTier = tier;

        // Sync sidebar pills
        var sPillsA = document.querySelectorAll('.sc-pill:not(.modal-sc-pill):not(.addon-sc-pill)');
        sPillsA.forEach(function(p) { p.classList.remove('active'); });
        var matchingSA = document.querySelector('.sc-pill:not(.modal-sc-pill):not(.addon-sc-pill)[data-tier="'+tier+'"]');
        if (matchingSA) matchingSA.classList.add('active');

        // Sync modal pills
        var mPillsA = document.querySelectorAll('.modal-sc-pill');
        mPillsA.forEach(function(p) { p.classList.remove('active'); });
        var matchingMA = document.querySelector('.modal-sc-pill[data-tier="'+tier+'"]');
        if (matchingMA) matchingMA.classList.add('active');

        // Update sidebar UI hooks (badge + send button)
        if(wrap) wrap.setAttribute('data-tier', tier);
        if(badge) badge.setAttribute('data-tier', tier);
        if(sendBtn) sendBtn.setAttribute('data-tier', tier);

        // Update Addon Screen styling DOM classes for accents
        var addonWrap = document.getElementById('addon-textarea-wrap');
        var addonBadge = document.getElementById('addon-sc-badge');
        var addonBadgeIcon = document.getElementById('addon-sc-badge-icon');
        var addonBadgeText = document.getElementById('addon-sc-badge-text');
        if(addonWrap) addonWrap.setAttribute('data-tier', tier);
        if(addonBadge) addonBadge.setAttribute('data-tier', tier);

        // Update Modal styling DOM classes for accents
        var modalWrap = document.getElementById('modal-textarea-wrap');
        var modalBadge = document.getElementById('modal-sc-badge');
        var modalBadgeIcon = document.getElementById('modal-sc-badge-icon');
        var modalBadgeText = document.getElementById('modal-sc-badge-text');
        if(modalWrap) modalWrap.setAttribute('data-tier', tier);
        if(modalBadge) modalBadge.setAttribute('data-tier', tier);

        if (tier === '0' || tier === 0) {
          if(badge) badge.style.display = 'none';
          if(sendText) sendText.textContent = '';
          if(addonBadge) addonBadge.style.display = 'none';
          if(modalBadge) modalBadge.style.display = 'none';
        } else {
          if(badge) badge.style.display = 'inline-flex';
          if(badgeIcon) badgeIcon.textContent = icons[tier] || 'star';
          if(badgeText) badgeText.textContent = 'SUPER COMMENT TIER ' + tier;
          if(sendText) sendText.textContent = '+$' + price + ' Super Comment';

          if(addonBadge) addonBadge.style.display = 'inline-flex';
          if(addonBadgeIcon) addonBadgeIcon.textContent = icons[tier] || 'star';
          if(addonBadgeText) addonBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;

          if(modalBadge) modalBadge.style.display = 'inline-flex';
          if(modalBadgeIcon) modalBadgeIcon.textContent = icons[tier] || 'star';
          if(modalBadgeText) modalBadgeText.textContent = 'SUPER COMMENT TIER ' + tier;
        }

        if (focusTarget) focusTarget.focus();
        syncPledgeTotal();
      });
    });

    function collapseSCOptions() {
      var container = document.getElementById('sc-options-container');
      if (container) container.classList.add('sc-options-collapsed');
    }

    textarea.addEventListener('focus', function() {
      var container = document.getElementById('sc-options-container');
      if (container) container.classList.remove('sc-options-collapsed');
    });

    // Collapse when textarea loses focus — delay so pill clicks can restore focus first
    textarea.addEventListener('blur', function() {
      setTimeout(function() {
        if (document.activeElement !== textarea) {
          collapseSCOptions();
        }
      }, 200);
    });

    // Collapse when user scrolls the comments list
    var commentsScrollEl = document.querySelector('.comments-scroll');
    if (commentsScrollEl) {
      commentsScrollEl.addEventListener('scroll', function() {
        collapseSCOptions();
        textarea.blur();
      }, { passive: true });
    }
    
    if (pledgeTextarea) {
      pledgeTextarea.addEventListener('focus', function() {
        var modalContainer = document.getElementById('modal-sc-options-container');
        if (modalContainer && modalContainer.classList.contains('sc-options-collapsed')) {
          modalContainer.classList.remove('sc-options-collapsed');
          // Only scrollIntoView on first expand to avoid jank on subsequent focuses
          if (!_modalPillsExpandedOnce) {
            _modalPillsExpandedOnce = true;
            setTimeout(function() {
              if (pledgeTextarea) pledgeTextarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 150);
          }
        }
      });
    }

    if (addonTextarea) {
      addonTextarea.addEventListener('focus', function() {
        var addonContainer = document.getElementById('addon-sc-options-container');
        if (addonContainer && addonContainer.classList.contains('sc-options-collapsed')) {
          addonContainer.classList.remove('sc-options-collapsed');
        }
      });
      addonTextarea.addEventListener('blur', function() {
        setTimeout(function() {
          if (document.activeElement !== addonTextarea) {
            var addonContainer = document.getElementById('addon-sc-options-container');
            if (addonContainer) addonContainer.classList.add('sc-options-collapsed');
          }
        }, 200);
      });
    }

    // Wire the SC info icon tooltip — appended to body to escape overflow:hidden on .sc-options-inner
    var scInfoBtn = document.querySelector('.sc-info');
    if (scInfoBtn) {
      var scTip = document.createElement('div');
      scTip.className = 'pp-filter-info-tip';
      scTip.style.cssText = [
        'display:none',
        'position:fixed',
        'width:260px',
        'background:#1e293b',
        'color:#e2e8f0',
        'font-size:13px',
        'line-height:1.6',
        'padding:14px 16px',
        'border-radius:12px',
        'z-index:9999',
        'box-shadow:0 8px 24px rgba(0,0,0,0.25)',
        'pointer-events:none'
      ].join(';');
      scTip.textContent = 'Show even more support to the creator by leaving a super comment! This comment will be specially highlighted with the comment tier you select.';
      document.body.appendChild(scTip);
      var scTipOpen = false;
      scInfoBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        scTipOpen = !scTipOpen;
        if (scTipOpen) {
          var rect = scInfoBtn.getBoundingClientRect();
          scTip.style.display = 'block';
          scTip.style.left = Math.max(8, rect.right - 260) + 'px';
          scTip.style.top = (rect.top - scTip.offsetHeight - 10) + 'px';
        } else {
          scTip.style.display = 'none';
        }
      });
      document.addEventListener('click', function() {
        if (scTipOpen) { scTipOpen = false; scTip.style.display = 'none'; }
      });
    }

    // Handle Send Logic
    function handleSuperCommentSubmit() {
      if (campaignEnded) {
        alert('This campaign has ended. Pledges are no longer accepted.');
        return;
      }
      if (!isLoggedIn) {
        if(window.showSuperCommentAuthError) window.showSuperCommentAuthError('Please log in to comment.');
        textarea.blur();
        return;
      }
      var content = (textarea.value || '').trim();
      var pledgeTextarea = document.getElementById('pp-pledge-comment');
      if (pledgeTextarea) {
        pledgeTextarea.value = content;
        pledgeTextarea.dispatchEvent(new Event('input', { bubbles: true }));
      }
      var addonTxt = document.getElementById('addon-backer-comment');
      if (addonTxt) {
        addonTxt.value = content;
        addonTxt.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Sync state to modal pills
      var mPills = document.querySelectorAll('.modal-sc-pill');
      mPills.forEach(function(p) { p.classList.remove('active'); });
      var matchingModalPill = document.querySelector('.modal-sc-pill[data-tier="'+window.ppSuperCommentTier+'"]');
      if(matchingModalPill) matchingModalPill.classList.add('active');

      // Sync state to addon pills
      var aPillsS = document.querySelectorAll('.addon-sc-pill');
      aPillsS.forEach(function(p) { p.classList.remove('active'); });
      var matchingAddonPillS = document.querySelector('.addon-sc-pill[data-tier="'+window.ppSuperCommentTier+'"]');
      if(matchingAddonPillS) matchingAddonPillS.classList.add('active');

      var pledgeBtn = document.querySelector('.stitch-pledge-popup .footer .btn-pledge') || document.querySelector('.pp-pledge-button');
      if (pledgeBtn) pledgeBtn.click();
      
      // Synchronous recalc — no setTimeout jank
      syncPledgeTotal();
    }
    
    if(sendBtn) sendBtn.addEventListener('click', function() { handleSuperCommentSubmit(); textarea.blur(); });
    textarea.addEventListener('keydown', function(e) {
       if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSuperCommentSubmit(); textarea.blur(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      initSuperCommentUI();
    });
  } else {
    init();
    initSuperCommentUI();
  }

}());
